import { useEffect, useState } from "react";
import api from "../api/axios";
import { API_ORIGIN } from "../api/apiConfig";

export const DEFAULT_ADMIN_LOGO = "/logo.png";

function resolveLogoUrl(value, fallback = DEFAULT_ADMIN_LOGO) {
  const logo = String(value || "").trim();
  if (!logo) return fallback;
  if (logo.startsWith("blob:") || logo.startsWith("data:") || logo.startsWith("http")) {
    return logo;
  }
  if (logo.startsWith("/uploads/")) return `${API_ORIGIN}${logo}`;
  return logo;
}

export default function useBrandingLogo() {
  const [logoUrl, setLogoUrl] = useState(DEFAULT_ADMIN_LOGO);

  useEffect(() => {
    let active = true;

    const applySettings = (settings) => {
      if (!active) return;
      setLogoUrl(resolveLogoUrl(settings?.general?.logo));
    };

    api
      .get("/settings")
      .then((res) => applySettings(res.data?.settings))
      .catch(() => {
        if (active) setLogoUrl(DEFAULT_ADMIN_LOGO);
      });

    const handleSettingsUpdated = (event) => applySettings(event.detail?.settings);
    window.addEventListener("fleetx-settings-updated", handleSettingsUpdated);

    return () => {
      active = false;
      window.removeEventListener("fleetx-settings-updated", handleSettingsUpdated);
    };
  }, []);

  return logoUrl;
}

export { resolveLogoUrl };
